import { pipe, map } from 'ramda';
import U from './../../../templates/shared/utils';

// This module adds the next and before step text below the Next Button.
const addStepTextInFooter = () => {

	// getStepNumber :: MaybeObject -> MaybeObject string -> string
	const getStepNumber = map( string => string.split( '_' ).pop() );

	// sum1 :: MaybeObject -> MaybeObject string -> number
	const sum1 = map( string => parseInt( string, 10 ) + 1 );

	// rest1 :: MaybeObject -> MaybeObject string -> number
	const rest1 = map( string => parseInt( string, 10 ) - 1 );

	// getStepIdFromElement :: MaybeObject DOMobject -> MaybeObject string
	const getNextStepIdFromElement = pipe(
		U.getElementId,
		getStepNumber,
		sum1,
		U.prependString( 'gf_step_1_' )
	);

	// getStepIdFromElement :: MaybeObject DOMobject -> MaybeObject string
	const getBeforeStepIdFromElement = pipe(
		U.getElementId,
		getStepNumber,
		rest1,
		U.prependString( 'gf_step_1_' )
	);

	// getPageIdFromDOMobject :: MaybeObject DOMobject -> MaybeObject string
	const getPageIdFromElement = pipe(
		U.getElementId,
		getStepNumber,
		U.prependString( 'gform_page_1_' )
	);

	// getStepTitle :: MaybeObject -> MaybeObject DOMobject -> MaybeObject string
	const getStepTitle = pipe(
		U.getElementFromParent( '.gf_step_label' ),
		U.getElementText
	);

	const main = () => {
		// returns maybe an Element
		const getStepPageElement = U.getElementWithoutStyle( '.gform_page' );

		// returns the Next step id or undefined
		const nextStepId = getNextStepIdFromElement( getStepPageElement ).value;

		// returns the Before step id or undefined
		const beforeStepId = getBeforeStepIdFromElement( getStepPageElement ).value;

		// returns the page id or undefined
		const pageId = getPageIdFromElement( getStepPageElement ).value;

		// returns the next step title or empty string
		const nextStepTitle = getStepTitle( U.getElement( `#${nextStepId}` ) ).getOrElse( '' );

		// returns the before step title or empty string
		const beforeStepTitle = getStepTitle( U.getElement( `#${beforeStepId}` ) ).getOrElse( '' );

		// returns maybe the actual step footer container element
		const stepFooterElement = U.getElement( `#${pageId} .gform_page_footer` );

		// Inversed order added
		U.insertAfter( stepFooterElement, `<div class='footer-step-title'>${nextStepTitle}</div>` );
		U.insertAfter( stepFooterElement, `<div class='footer-step-title first-step'>${beforeStepTitle}</div>` );
	};

	main();
};

export default addStepTextInFooter;
